import { Button, Col, Form, Select, Row } from "antd";
import FloatInput from "../../../common/components/FloatInput";
import FloatSelect from "../../../common/components/FloatSelect";
import { AuctionHistorySearch } from "../../types";

const { Option } = Select;

interface FilterProps {
    setSubmitValue: React.Dispatch<React.SetStateAction<AuctionHistorySearch | undefined>>,
    triggerSearch: (submitValue: AuctionHistorySearch) => void,
}

const AuctionHistoryFilter = ({ setSubmitValue, triggerSearch }: FilterProps) => {
    const [form] = Form.useForm();

    const onReset = () => {
        setSubmitValue({});
        form.resetFields();
    }

    const onValuesChange = (changedValues: any, allValues: any) => {
        let toDateValue = form.getFieldValue("toDate");
        if (changedValues.fromDate && toDateValue && changedValues.fromDate > toDateValue) {
            form.setFieldsValue({
                toDate: ""
            })
        }
    }

    const onFinish = (values: any) => {
        let submitValue: AuctionHistorySearch = {
            ...!Number.isNaN(values.startStatus) ? { startStatus: values.startStatus } : {},
            ...!Number.isNaN(values.registerStatus) ? { registerStatus: values.registerStatus } : {},
            ...!Number.isNaN(values.preCostStatus) ? { preCostStatus: values.preCostStatus } : {},
            ...values.productName ? { productName: values.productName.trim() } : {},
        }
        setSubmitValue(submitValue);
        triggerSearch(submitValue);
    }

    return (
        <Form
            className="custom-form"
            name="register"
            form={form}
            colon={false}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            style={{ background: 'white', padding: 15, borderRadius: 15 }}
        >
            <div className="font-size-16 font-bold">Tên tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="productName"
                        style={{ marginBottom: 0 }}>
                        <FloatInput label="" placeholder="Nhập tên tài sản cần tìm" className="filter-input" maxLength={200} allowClear />
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Trạng thái đấu giá</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="startStatus"
                        style={{ marginBottom: 0 }}>
                        <FloatSelect
                            allowClear
                            label=""
                            placeholder="Chọn trạng thái đấu giá"
                            className="custom-select filter-select">
                            <Option value={1}>Sắp diễn ra</Option>
                            <Option value={2}>Đang diễn ra</Option>
                            {/* <Option value={3}>Đang tạm dừng</Option> */}
                            <Option value={4}>Đã kết thúc</Option>
                        </FloatSelect>
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Trạng thái đăng ký</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="registerStatus"
                        style={{ marginBottom: 0 }}>
                        <FloatSelect
                            allowClear
                            label=""
                            placeholder="Chọn trạng thái đăng ký"
                            className="custom-select filter-select">
                            <Option value={0}>Đã nộp hồ sơ</Option>
                            <Option value={1}>Đã đăng ký thành công</Option>
                            <Option value={2}>Từ chối tham gia</Option>
                            <Option value={3}>Đăng ký không hợp lệ</Option>
                        </FloatSelect>
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Trạng thái tiền đặt trước</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="preCostStatus"
                        style={{ marginBottom: 0 }}>
                        <FloatSelect
                            allowClear
                            label=""
                            placeholder="Chọn trạng thái tiền đặt trước"
                            className="custom-select filter-select">
                            <Option value={0}>Chưa nộp tiền đặt trước</Option>
                            <Option value={1}>Chờ đối soát</Option>
                            <Option value={2}>Xác nhận nộp tiền đặt trước</Option>
                            <Option value={3}>Không xác nhận nộp tiền đặt trước</Option>
                        </FloatSelect>
                    </Form.Item>
                </Col>
            </Row>

            <Row style={{ marginTop: 30 }} align="middle" gutter={10}>
                <Col span={12}>
                    <Button className="button-gray" style={{ height: 45 }} block onClick={onReset}>NHẬP LẠI</Button>
                </Col>
                <Col span={12}>
                    <Button className="button-light-yellow" style={{ height: 45 }} block htmlType="submit">TÌM KIẾM</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default AuctionHistoryFilter;